import { render, staticRenderFns } from "./SettingsWebhooksResponse.vue?vue&type=template&id=0c8d8564"
import script from "./SettingsWebhooksResponse.vue?vue&type=script&lang=js"
export * from "./SettingsWebhooksResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c8d8564')) {
      api.createRecord('0c8d8564', component.options)
    } else {
      api.reload('0c8d8564', component.options)
    }
    module.hot.accept("./SettingsWebhooksResponse.vue?vue&type=template&id=0c8d8564", function () {
      api.rerender('0c8d8564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Settings/SettingsWebhooksResponse.vue"
export default component.exports